import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

export const Wrapper = styled.div`
  @media ${mediaSmallOrTiny} {
    min-height: 0;
  }
`;
